import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["email", "button", "message"];
  static values = { url: String };

  async subscribe(event) {
    event.preventDefault();

    const email = this.emailTarget.value.trim();

    if (!this.validateEmail(email)) {
      this.showMessage("Veuillez entrer une adresse email valide", "error");
      return;
    }

    this.setLoading(true);

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken,
          Accept: "application/json",
        },
        body: JSON.stringify({ email: email }),
      });

      const data = await response.json();

      if (response.ok) {
        this.showMessage(data.message, "success");
        this.emailTarget.value = "";
        localStorage.setItem("subscriber_email", email);
      } else {
        this.showMessage(data.error || "Une erreur est survenue", "error");
      }
    } catch (error) {
      this.showMessage("Une erreur est survenue", "error");
    } finally {
      this.setLoading(false);
    }
  }

  validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  showMessage(message, type) {
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = message;
      this.messageTarget.classList.remove(
        "hidden",
        "text-cta",
        "text-red-300",
      );
      this.messageTarget.classList.add(
        type === "success" ? "text-cta" : "text-red-300",
      );

      setTimeout(() => {
        this.messageTarget.classList.add("hidden");
      }, 5000);
    }
  }

  setLoading(loading) {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = loading;
      this.buttonTarget.innerHTML = loading
        ? '<svg class="animate-spin h-5 w-5 mx-auto text-cta" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>'
        : this.buttonTarget.dataset.originalText;
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content;
  }
}
